<template lang="pug">
  v-dialog(v-model="is_show" width="600")
    v-card
      v-card-title
        h2 印刷メニュー
        v-spacer
        v-icon(@click="close") mdi-close-circle-outline
      v-card-subtitle
        | 帳票タイプ印刷
      v-card-text
        v-row(justify="space-around")
          v-checkbox(v-model="ssform" label="請求・納品・受領書")
          v-checkbox(v-model="trform" label="見積り・売上伝票・控え")
      v-card-actions
        v-spacer
        //- v-btn(outlined color="primary" @click="printForm") 印刷
        v-btn(outlined color="primary" :href="form_pr_link") 印刷
        v-spacer
      v-card-subtitle A4タイプ印刷
      v-card-text
        v-row(justify="space-around")
          v-checkbox(v-model="a4dl" label="納品書")
          v-checkbox(v-model="a4es" label="見積り書")
          v-checkbox(v-model="a4bl" label="請求書")
          v-checkbox(v-model="a4rc" label="受領書")
      v-card-actions
        v-spacer
        v-btn(outlined color="primary" @click="printA4") 印刷
        v-spacer
        v-btn(outlined color="primary" @click="showPv") 表示
        v-spacer
    //- printA4(ref="printA4delivery" v-bind:sales_slip="sales_slip" :class="a4class")
    //- printA4(ref="printA4delivery" v-bind:sales_slip="sales_slip" :class="a4class")
</template>

<script>
  // import printA4delivery from './printA4delivery'
  // import printA4estimate from './printA4estimate'

  export default {
    name: 'printDialog',
    // components: { printA4delivery },
    data() { return {
      is_show: false,
      ssform: true,
      trform: true,
      a4dl: true,
      a4es: false,
      a4bl: false,
      a4rc: false,
      a4class: 'd-none',
    }},
    props: [ 'sales_slip' ],
    computed: {
      form_pr_link() {
        const base = process.env.VUE_APP_API_BASE + '/sales_slips/' + this.sales_slip.id + '?'
        if (this.ssform && this.trform)
          return base + 'pr%5Bf1%5D=1&pr%5Bf2%5D=1'
        else if (this.ssform)
          return base + 'pr%5Bf1%5D=1'
        else if (this.trform)
          return base + 'pr%5Bf2%5D=1'
        else
          return '#'
      }
    },
    methods: {
      open() {
        this.is_show = true
      },
      close() {
        this.is_show = false
      },
      printForm() {
        let url = '/print?type=pr'
        if (!this.ssform && !this.trform) return;
        if (this.ssform) url += '&fm=1'
        if (this.trform) url += '&tr=1'
        window.open(`${url}&id=${this.sales_slip.id}`, 'uden_print')
        this.is_show = false
      },
      hideA4() {
        this.a4class='d-none'
      },
      printA4() {
        let url = '/print?type=pr'
        if (!this.a4dl && !this.a4es && !this.a4bl && !this.a4rc) return;
        if (this.a4dl) url += '&dl=1'
        if (this.a4es) url += '&es=1'
        if (this.a4bl) url += '&bl=1'
        if (this.a4rc) url += '&rc=1'
        window.open(`${url}&id=${this.sales_slip.id}`, 'uden_print')
        this.is_show = false
      },
      showPv() {
        let url = '/print?type=pv'
        if (!this.a4dl && !this.a4es && !this.a4bl && !this.a4rc) return;
        if (this.a4dl) url += '&dl=1'
        if (this.a4es) url += '&es=1'
        if (this.a4bl) url += '&bl=1'
        if (this.a4rc) url += '&rc=1'
        window.open(`${url}&id=${this.sales_slip.id}`, 'uden_print')
      }
    }
  }
</script>
